import { render, staticRenderFns } from "./ClearingManagementList.vue?vue&type=template&id=06b3b0c7"
import script from "./ClearingManagementList.vue?vue&type=script&lang=js"
export * from "./ClearingManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports